import { ConfigData } from "@/models/config";
import UserServices from "@/services/main/UserServices";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type UseConfigProps = {
  config: ConfigData;
  currency?: string;
  options?: Omit<
    UseQueryOptions<ConfigData, unknown, ConfigData>,
    "queryKey" | "queryFn"
  >;
};

export const useConfigQuery = ({ config, options,currency }: UseConfigProps) => {
  return useQuery<ConfigData, unknown, ConfigData>({
    queryKey: ["config"],
    queryFn: async () => {
      const result = await UserServices.getConfig();
      console.log("config currency in query ",currency);
      return {...result, currency: currency};
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: Infinity,
    initialData: {...config, currency: currency},
    ...options,
  });
};
